import {DatabaseInfo} from '@/generated/graphql'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import React from 'react'
import {shortenDate} from '@/utils/dateUtils'
import Box from '@mui/material/Box'
import MuiTableContainer from '@/components/common/MuiTableContainer'
import DataInfoTableHead from '@/components/pages/DataInfoPage/table/DataInfoTableHead'
import CollapsibleSection from '@/components/pages/DataInfoPage/table/CollapsibleSection'
import Button from '@mui/material/Button'
import {useDispatch, useSelector} from 'react-redux'
import {InitialStateType} from '@/store/reducers'
import DatabaseDetailDialog from '@/components/pages/DataInfoPage/database/DatabaseDetailDialog'
import {SET_DATABASE_DETAIL} from '@/store/types'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'
import Link from '@mui/material/Link'
import {StyledTableCell} from '@/components/common/CustomStyledComponents'

const headers = ['ID', 'Name', 'Version', 'Reference Genome', 'Creation Date', 'Samples Count', '']

type DatabaseTableProps = {
    databases: DatabaseInfo[]
}

const DatabaseTable = ({databases}: DatabaseTableProps) => {

    const dispatch = useDispatch()
    const {databaseIdDetail} = useSelector((state: InitialStateType) => state.dataInfo)
    
    return (
        <CollapsibleSection header={'Databases (' + (databases.length || 0)  + ')'}>
            <Box paddingTop={2}>
                <MuiTableContainer maxHeight='35vh' noData={!databases || databases.length <= 0} borderRadius='1em'>
                    <DataInfoTableHead headers={headers} hideCheckbox/>
                    <TableBody>
                        {databases?.map((database, idx) => (
                            <TableRow key={database.database_id + '-' + idx}>
                                <StyledTableCell>
                                    <Link color={ThemeColorsHospitalic.INFO_DARK} onClick={() => dispatch(SET_DATABASE_DETAIL(database.database_id))}>
                                        {database.database_id}
                                    </Link>
                                </StyledTableCell>
                                <StyledTableCell>{database.database_name}</StyledTableCell>
                                <StyledTableCell>{database.version}</StyledTableCell>
                                <StyledTableCell>{database.reference_genome}</StyledTableCell>
                                <StyledTableCell>{shortenDate(database.created_date)}</StyledTableCell>
                                <StyledTableCell>{database.num_of_samples}</StyledTableCell>
                                <StyledTableCell align="right"><Button variant='contained' size="small" onClick={() => dispatch(SET_DATABASE_DETAIL(database.database_id))}>Detail</Button></StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </MuiTableContainer>
                {!!databaseIdDetail && <DatabaseDetailDialog databaseId={databaseIdDetail}/>}
            </Box>
        </CollapsibleSection>
    )
}

export default DatabaseTable